// extracted by mini-css-extract-plugin
export var container = "NewsHeader-module--container--v82la";
export var category = "NewsHeader-module--category--+EM00";
export var arrow = "NewsHeader-module--arrow--HSVAj";